import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";

const projects = [
  {
    title: "Health Insurance Claim Automation",
    tech: ["JavaScript", "Selenium"],
    description:
      "Automation system for claim adjudication that reduced manual doctor intervention and increased throughput.",
    // github: "#",
    // demo: "#",
  },
  {
    title: "MoSahay Job Portal",
    tech: ["React", "JavaScript"],
    description:
      "Job portal connecting blue-collar workers with employment opportunities through a modern web interface.",
    // github: "#",
    // demo: "#",
  },
  {
    title: "Policy Digitization System",
    tech: ["React", "Node"],
    description:
      "System that converted 2500+ policy products into secure, searchable digital formats for insurers.",
    // github: "#",
    // demo: "#",
  },
  {
    title: "E-commerce Website",
    tech: ["React", "Node"],
    description:
      "Designed and developed an e-commerce website for a client.",
    // github: "#",
    demo: "https://shop.tahirjamal.com",
    demo_admin: "https://shop.tahirjamal.com/admin",
  },
];

export default function Projects() {
  return (
    <>
      <div className="section-header">
        <p className="section-kicker">Projects</p>
        <h2 className="section-title">Selected work</h2>
        <p className="section-description">
          A few representative projects that highlight my focus on automation, health-tech, and
          robust frontend architecture.
        </p>
      </div>

      <div className="projects-grid grid grid-3">
        {projects.map((project) => (
          <article key={project.title} className="card">
            <div className="project-image">
              <div className="project-image-overlay" />
              <div className="project-hover">
                <div className="project-hover-label">View details</div>
                <div className="project-hover-title">{project.title}</div>
              </div>
            </div>
            <div className="card-body">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tech">
                {project.tech.map((t) => (
                  <span key={t} className="pill">
                    {t}
                  </span>
                ))}
              </div>
              <div className="project-actions">
                {project.github && (
                  <a
                    href={project.github}
                    className="btn btn-outline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaGithub size={14} />
                    <span>GitHub</span>
                  </a>
                )}
                {project.demo && (
                  <a
                    href={project.demo}
                    className="btn btn-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaExternalLinkAlt size={13} />
                    <span>Live Demo</span>
                  </a>
                )}
                {project.demo_admin && (
                  <a
                    href={project.demo_admin}
                    className="btn btn-outline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaExternalLinkAlt size={13} />
                    <span>Admin Panel</span>
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}

